/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MeiTiChanPinChaXunDTO,
  MeiTiChanPinChuangJianDTO,
  MeiTiChanPinGengXinDTO,
  ResponseApiIPageMeiTiChanPinLieBiaoXiangYingDTO,
  ResponseApiLong,
  ResponseApiMapIntString,
  ResponseApiMeiTiChanPinLieBiaoXiangYingDTO,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class MeiTiChanPinGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags MeiTiChanPinGuanLi
   * @name CategoryListUsingGet
   * @summary 产品分类信息
   * @request GET:/dsp-admin/api/publisher/product/category/list
   * @secure
   */
  categoryListUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiMapIntString, void>({
      path: `/dsp-admin/api/publisher/product/category/list`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiChanPinGuanLi
   * @name CreatePublisherProductUsingPost
   * @summary 创建媒体产品
   * @request POST:/dsp-admin/api/publisher/product/create
   * @secure
   */
  createPublisherProductUsingPost = (
    createDTO: MeiTiChanPinChuangJianDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/publisher/product/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiChanPinGuanLi
   * @name PublisherProductListUsingPost
   * @summary 分页查询媒体产品列表
   * @request POST:/dsp-admin/api/publisher/product/list
   * @secure
   */
  publisherProductListUsingPost = (
    queryDTO: MeiTiChanPinChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageMeiTiChanPinLieBiaoXiangYingDTO, void>({
      path: `/dsp-admin/api/publisher/product/list`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiChanPinGuanLi
   * @name GetPublisherProductByIdUsingGet
   * @summary 获取媒体产品信息
   * @request GET:/dsp-admin/api/publisher/product/{id}
   * @secure
   */
  getPublisherProductByIdUsingGet = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiMeiTiChanPinLieBiaoXiangYingDTO, void>({
      path: `/dsp-admin/api/publisher/product/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiChanPinGuanLi
   * @name UpdatePublisherProductUsingPut
   * @summary 更新媒体产品
   * @request PUT:/dsp-admin/api/publisher/product/{id}
   * @secure
   */
  updatePublisherProductUsingPut = (
    updateDTO: MeiTiChanPinGengXinDTO,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/publisher/product/${id}`,
      method: "PUT",
      body: updateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiChanPinGuanLi
   * @name DeletePublisherProductUsingDelete
   * @summary 删除媒体产品
   * @request DELETE:/dsp-admin/api/publisher/product/{id}
   * @secure
   */
  deletePublisherProductUsingDelete = (
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/publisher/product/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new MeiTiChanPinGuanLi();
